import { createAction } from 'redux-actions';

export const getQuestionnaireRequest = createAction('GET_QUESTIONNAIRE_REQUEST');
export const getQuestionnaireSuccess = createAction('GET_QUESTIONNAIRE_SUCCESS');
export const getQuestionnaireFail = createAction('GET_QUESTIONNAIRE_FAIL');

export const saveQuestionnaireAnswersRequest = createAction('SAVE_QUESTIONNAIRE_ANSWERS_REQUEST');
export const saveQuestionnaireAnswersSuccess = createAction('SAVE_QUESTIONNAIRE_ANSWERS_SUCCESS');
export const saveQuestionnaireAnswersFail = createAction('SAVE_QUESTIONNAIRE_ANSWERS_FAIL');

export const getQuestionnaireAnswersRequest = createAction('GET_QUESTIONNAIRE_ANSWERS_REQUEST');
export const getQuestionnaireAnswersSuccess = createAction('GET_QUESTIONNAIRE_ANSWERS_SUCCESS');
export const getQuestionnaireAnswersFail = createAction('GET_QUESTIONNAIRE_ANSWERS_FAIL');

export const setDraftQuestionnaireAnswersRequest = createAction(
  'SET_DRAFT_QUESTIONNAIRE_ANSWERS_REQUEST',
);
export const setDraftQuestionnaireAnswersSuccess = createAction(
  'SET_DRAFT_QUESTIONNAIRE_ANSWERS_SUCCESS',
);
export const setDraftQuestionnaireAnswersFail = createAction(
  'SET_DRAFT_QUESTIONNAIRE_ANSWERS_FAIL',
);

export const confirmQuestionnaireRequest = createAction('CONFIRM_QUESTIONNAIRE_REQUEST');
export const confirmQuestionnaireSuccess = createAction('CONFIRM_QUESTIONNAIRE_SUCCESS');
export const confirmQuestionnaireFail = createAction('CONFIRM_QUESTIONNAIRE_FAIL');

export const setCurrentFormIndex = createAction('SET_CURRENT_FORM_INDEX');
export const showRecheckModal = createAction('SHOW_RECHECK_MODAL');
export const hideRecheckModal = createAction('HIDE_RECHECK_MODAL');
